import type { ZodiacSign } from '@entities/profile/types';

export const zodiacCompatibilityMap: Record<
  ZodiacSign,
  Record<ZodiacSign, number>
> = {
  aries: {
    aries: 80,
    taurus: 55,
    gemini: 80,
    cancer: 30,
    leo: 90,
    virgo: 50,
    libra: 65,
    scorpio: 70,
    sagittarius: 85,
    capricorn: 25,
    aquarius: 80,
    pisces: 45,
  },
  taurus: {
    aries: 55,
    taurus: 85,
    gemini: 50,
    cancer: 85,
    leo: 60,
    virgo: 95,
    libra: 45,
    scorpio: 75,
    sagittarius: 40,
    capricorn: 90,
    aquarius: 25,
    pisces: 80,
  },
  gemini: {
    aries: 80,
    taurus: 50,
    gemini: 75,
    cancer: 30,
    leo: 85,
    virgo: 55,
    libra: 90,
    scorpio: 40,
    sagittarius: 70,
    capricorn: 25,
    aquarius: 95,
    pisces: 20,
  },
  cancer: {
    aries: 30,
    taurus: 85,
    gemini: 30,
    cancer: 85,
    leo: 50,
    virgo: 85,
    libra: 40,
    scorpio: 95,
    sagittarius: 30,
    capricorn: 80,
    aquarius: 25,
    pisces: 90,
  },
  leo: {
    aries: 90,
    taurus: 60,
    gemini: 85,
    cancer: 50,
    leo: 70,
    virgo: 45,
    libra: 85,
    scorpio: 55,
    sagittarius: 95,
    capricorn: 25,
    aquarius: 70,
    pisces: 35,
  },
  virgo: {
    aries: 50,
    taurus: 95,
    gemini: 55,
    cancer: 85,
    leo: 45,
    virgo: 80,
    libra: 50,
    scorpio: 85,
    sagittarius: 45,
    capricorn: 95,
    aquarius: 40,
    pisces: 60,
  },
  libra: {
    aries: 65,
    taurus: 45,
    gemini: 90,
    cancer: 40,
    leo: 85,
    virgo: 50,
    libra: 80,
    scorpio: 50,
    sagittarius: 90,
    capricorn: 25,
    aquarius: 95,
    pisces: 40,
  },
  scorpio: {
    aries: 70,
    taurus: 75,
    gemini: 40,
    cancer: 95,
    leo: 55,
    virgo: 85,
    libra: 50,
    scorpio: 70,
    sagittarius: 55,
    capricorn: 90,
    aquarius: 35,
    pisces: 95,
  },
  sagittarius: {
    aries: 85,
    taurus: 40,
    gemini: 70,
    cancer: 30,
    leo: 95,
    virgo: 45,
    libra: 90,
    scorpio: 55,
    sagittarius: 80,
    capricorn: 45,
    aquarius: 90,
    pisces: 20,
  },
  capricorn: {
    aries: 25,
    taurus: 90,
    gemini: 25,
    cancer: 80,
    leo: 25,
    virgo: 95,
    libra: 25,
    scorpio: 90,
    sagittarius: 45,
    capricorn: 85,
    aquarius: 50,
    pisces: 85,
  },
  aquarius: {
    aries: 80,
    taurus: 25,
    gemini: 95,
    cancer: 25,
    leo: 70,
    virgo: 40,
    libra: 95,
    scorpio: 35,
    sagittarius: 90,
    capricorn: 50,
    aquarius: 85,
    pisces: 40,
  },
  pisces: {
    aries: 45,
    taurus: 80,
    gemini: 20,
    cancer: 90,
    leo: 35,
    virgo: 60,
    libra: 40,
    scorpio: 95,
    sagittarius: 20,
    capricorn: 85,
    aquarius: 40,
    pisces: 85,
  },
};

export type GetZodiacCompatibilityParams = {
  userSign: ZodiacSign;
  partnerSign: ZodiacSign;
};

export function getZodiacCompatibility({
  userSign,
  partnerSign,
}: GetZodiacCompatibilityParams): number {
  return (
    zodiacCompatibilityMap[userSign]?.[partnerSign] ??
    zodiacCompatibilityMap[partnerSign]?.[userSign] ??
    50
  );
}
